<div class="spinner-loader">
    <div class="wrapper">
        <div class="loader"></div>
    </div>
    <!-- <div class="spinner-text">{{ spinnerText }}</div> -->
    <div class="spinner-text">Loading...</div>
</div>